// extracted by mini-css-extract-plugin
export default {"mediumCell":"AuditionsTableHeader_mediumCell__YfDu1","largeCell":"AuditionsTableHeader_largeCell__W29hR"};